import { formatDate } from '@/core/localization/date';

// cutoff: hour of the day that limit same-day delivery
export const cutOffParser = (
  cutOff: number,
): { hours: string; minutes: string } => {
  if (!cutOff) {
    return { hours: '00', minutes: '00' };
  }
  const time = formatDate(new Date(cutOff), {
    hour12: false,
    hour: 'numeric',
    minute: 'numeric',
  }).toString();
  const [hours, minutes] = time.split(':');
  return { hours, minutes };
};
